import { createSlice } from '@reduxjs/toolkit'
const initialEditUserState = {
    isError: false,
    error: '',
    loading: false,
    user: {
        name_tx: '',
        company_tx: '',
        email_tx: '',
        phone_tx: '',
        cell_tx: '',
        username_tx: '',
        hash_tx: '',
        role_id: '',
        ref_user_cd: '',
        address_tx: '',
        zip_tx: '',
        city_tx: '',
        state_tx: '',
        congregation: '',
        type: '',
        backupType:'',
        division_access: [],
        backupDivisionAccess: [],
        note_tx: '',
        billable_yn: '0',
        bill_type_tx: 'Manual', // Add bill_type_tx field with default 'Manual'
        manual_device_count: '',
        user_login_count: 0,
    },
    userTypeOptions: [],
    congregationOption: [],
    states: [],
}

export const editUserSlice = createSlice({
    name: 'editUser',
    initialState: initialEditUserState,
    reducers: {
        updateEditUserState: (state, action) => {
            return { ...state, ...action?.payload }
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setError: (state, action) => {
            const { isError, error } = action.payload
            state.isError = isError
            state.error = error
        },
    },
})
export const { updateEditUserState, setLoading, setError } =
    editUserSlice.actions
export default editUserSlice.reducer
